<template>
  <div class="md-layout">
    <div id="your-request" class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-large-size-80 md-xlarge-size-70 page-container page-container" style="margin-top:-20px;">
      <div class="md-layout">
        <div class="md-layout-item md-size-20 md-small-hide page-container-side">
        </div>
        <div class="md-layout-item md-size-80 md-small-size-100">
          <div class="page-container-section">
            <div v-if="!showContactUs">
              <!-- Title -->
              <div class="md-layout">
                <div class="md-layout-item">
                  <div>
                    <h3 class="page-sub-title">{{$t('service-request')}}<span v-if="debug" style="border:1px solid red;display:none">  </span></h3>
                    <p v-html="$t('select-one-service')"></p>
                    <div  v-if="debug && false" style="border:1px solid red;display:none">
                      {{debug}} is not available for refund/replacement. Please contact us for assistance.
                    </div>
                  </div>
                </div>
              </div>
              <!-- Message -->
              <div class="md-layout" v-if="showSelectMsg">
                <div class="md-layout-item md-error">
                  {{$t('select-one-servcie-2')}}
                </div>
              </div>
              <!-- Services -->
              <div class="md-layout" id="select-service">
                <div class="md-layout-item md-size-100">
                  <md-checkbox v-model="serviceRequired" value="refund" v-on:change="forceRerenderReasonSection" :disabled="actionAvailable.indexOf(1)==-1" v-show="!(actionAvailable.indexOf(1)==-1)">{{$t('return-products')}}</md-checkbox>
                </div>
                <div class="md-layout-item md-size-100 md-error" v-if="refundNotAvailable && refundNotAvailable.length>0" v-html="$t('qualifies-refund', {refundNotAvailable: refundNotAvailable})">
                </div>
                <div class="md-layout-item md-size-100">
                  <md-checkbox v-model="serviceRequired" value="repair" v-on:change="forceRerenderReasonSection" :disabled="actionAvailable.indexOf(2)==-1">{{$t('replace-products')}}</md-checkbox> <span style="display: none">[ {{!(actionAvailable.indexOf(2)==-1)}} ]</span>
                </div>
                <div class="md-layout-item md-size-100 md-error" v-if="repairNotAvailable && repairNotAvailable.length>0" v-html="$t('qualifies-replace', {repairNotAvailable: repairNotAvailable})">
                </div>
                <div class="md-layout-item md-size-100">
                  <md-checkbox v-model="serviceRequired" value="contact-us" v-on:change="forceRerenderReasonSection" :disabled="actionAvailable.indexOf(3)==-1">{{$t('contact-us-assistance')}}</md-checkbox>
                </div>
              </div>
              <!-- Reason and Fault List -->
              <div class="md-layout">
                <div class="md-layout-item md-size-100">
                  <h3 class="page-sub-title" v-if="serviceRequired=='refund'">{{$t('return-information')}}</h3>
                  <h3 class="page-sub-title" v-if="serviceRequired=='repair'">{{$t('replacement-information')}}</h3>
                </div>
              </div>
              <div class="md-layout" v-if="showFaultErrorMsg">
                <div class="md-layout-item md-error">
                  {{$t('fill-in-all')}}
                </div>
              </div>
              <return-reason :products="productSelected" :active="activeTab" :type="serviceRequired" v-if="renderReasonSection&&(serviceRequired=='refund'||serviceRequired=='repair')" v-on:tabChanged="reasonTabChanged" />
            </div>
            <!-- Contact Us -->
            <div class="md-layout" v-if="serviceRequired=='contact-us'">
              <div class="md-layout-item md-size-100" style="padding-top: 30px;">
                <md-field>
                  <label>{{$t('message')}}</label>
                  <md-textarea v-model="message" md-counter="200"></md-textarea>
                </md-field>
              </div>
              <div class="md-layout-item md-size-100 md-error" style="margin-top:-30px" v-if="showContactUsErrorMsg">
                <p>
                  {{$t('enter-message')}}
                </p>
              </div>
            </div>
            <!-- Submit Button -->
            <div class="md-layout">
              <div class="md-layout-item text-right">
                <md-button type="button" class="md-raised md-accent" :disabled="loading" v-on:click="next()">
                  {{$t('submit')}} <md-progress-spinner class="md-primary" md-mode="indeterminate" :md-value="80" :md-diameter="14" :md-stroke="2" v-if="loading"></md-progress-spinner>
                </md-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="md-layout">
        <div class="md-layout-item">
          <md-snackbar :md-active.sync="showErrorMsg" :md-duration="8000">{{$t('encountered-error')}}</md-snackbar>
          <md-snackbar :md-active.sync="showSuccessMsg" :md-duration="8000">Success</md-snackbar>
          <md-snackbar :md-active.sync="showAgreeMsg" :md-duration="8000">Please acknowledge the above statement.</md-snackbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ReturnReason from '../components/ReturnReason'
  import { mapState, mapMutations } from 'vuex'
  import * as types from '../store/mutation-types'
  import Auth from '../mixins/auth'
  import { apiServer, publicPath } from '../config'

  export default {
    name: 'YourRequest',
    components: {
      ReturnReason
    },
    data: () => ({
      productSelected: [],
      currentProduct: '',
      loading: false,
      qualityIssue: 'no',
      returnReason: '',
      faultCategory: '',
      faultDesc: '',
      message: '',
      actionAvailable: [],
      showSelectMsg: false,
      showFaultErrorMsg: false,
      refundNotAvailable: '',
      repairNotAvailable: '',
      serviceAvailable: true,
      serviceRequired: '',
      showContactUs: false,
      showContactUsErrorMsg: false,
      showSuccessMsg: false,
      showErrorMsg: false,
      activeTab: '',
      renderReasonSection: true,
      showAgreeMsg: false,
      debug: false
    }),
    computed: {
      ...mapState({
        store: 'store',
        step: 'step',
        productFaultInfo: 'productFaultInfo'
      })
    },
    async created() {
      this.loading = true
      this.showPageLoading()
      const r = await this.$http.request({ url: `${apiServer}/api/your-request?store=` + this.store, method: 'get', headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).catch(() => { this.loading = false })
      if (r && r.status == 200) {
        if (r.data) {
          this.actionAvailable = r.data.actionAvailable
          if (r.data.productSelected && r.data.productSelected.length > 0) {
            this.productSelected = r.data.productSelected
            this.loadAvailableMsg(r.data.productSelected)
          }
          if (r.data.actionSelected && r.data.actionSelected == 1) this.serviceRequired = 'refund'
          if (r.data.actionSelected && r.data.actionSelected == 2) this.serviceRequired = 'repair'
          if (r.data.actionSelected && (r.data.actionSelected == 4 || r.data.actionSelected == 5)) {
            this.serviceRequired = 'contact-us'
            this.showContactUs = true
          }
          this.serviceAvailable = r.data.allowService
          this.debug = (window.location.href.indexOf('localhost') == -1) ? false : true

        }
        this.loading = false
        this.hidePageLoading()
        this.$scrollTo('#your-request')
      }
      else {
        this.loading = false
        this.showErrorMsg = true
        this.hidePageLoading()
      }
    },
    methods: {
      ...mapMutations({
        changeStore: types.CHANGE_STORE,
        changeStep: types.CHANGE_STEP,
        showPageLoading: types.SHOW_LOADING,
        hidePageLoading: types.HIDE_LOADING,
        updateFaultMsg: types.CHANGE_FAULT_MSG
      }),
      next() {
        if (this.serviceRequired == '') {
          this.showSelectMsg = true
          return
        }
        this.loading = true
        this.showPageLoading()
        if (this.serviceRequired == 'contact-us') {
          if (!this.message || this.message.length == 0) {
            this.showContactUsErrorMsg = true
            setTimeout(() => { this.showContactUsErrorMsg = false }, 1000*5)
            this.loading = false
            this.hidePageLoading()
            return
          }
          this.$http.post(`${apiServer}/api/your-request/contact-us`, { message: this.message, store: this.store }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
            this.hidePageLoading()
            this.loading = false
            //window.console.log(data)
            if (data && data.status == 'success') {
              //this.showSuccessMsg = true
              this.$router.push(`${publicPath}/contact-us-success`)
            }
          }).catch(() => {
            this.hidePageLoading()
            this.loading = false
            this.showErrorMsg = true
          })
        } else {
          this.loadFaultInfo()


          if (!this.faultInfoVerify()) {
            this.hidePageLoading()
            this.loading = false
            // this.showFaultErrorMsg = true
            this.$scrollTo('#select-service')
            return
          }


          this.$http.post(`${apiServer}/api/your-request/submit`, {
            serviceRequired: this.serviceRequired == 'refund' ? 1 : 2,
            items: this.productSelected,
            store: this.store
          }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
            this.hidePageLoading()
            this.loading = false
            if (data && data.status == 'success' && data.rmaNo && data.rmaId) {
              localStorage.rma_rmaNo = data.rmaNo
              localStorage.rma_rmaId = data.rmaId
              this.$router.push(`${publicPath}/confirmation`)
            }
            else if (data && data.status == 'address')
              this.$router.push(`${publicPath}/address`)
            else {
              this.showErrorMsg = true
              //alert(JSON.stringify(data))
            }
          }).catch(() => {
            this.hidePageLoading()
            this.loading = false
            this.showErrorMsg = true
          })


        }
      },
      loadFaultInfo() {
     //   window.console.log(this.productFaultInfo)
        if (this.productFaultInfo &&
          this.productFaultInfo.reason &&
          this.productFaultInfo.faultCode &&
          this.productFaultInfo.comments
          && this.productSelected && this.productSelected.length > 0)
          this.productSelected.forEach(a => {
            const reason = this.productFaultInfo.reason[a.sourceId] ?? ''
            if (reason && reason.length > 0) a.faultCode = reason
            if (this.productFaultInfo.faultCode[a.sourceId])
              a.faultCode = this.productFaultInfo.faultCode[a.sourceId]
            a.comments = this.productFaultInfo.comments[a.sourceId] ?? ''
            a.otherComments = this.productFaultInfo.otherComments[a.sourceId] ?? ''
            if (this.productFaultInfo.cosmetic[a.sourceId] &&
              this.productFaultInfo.damageImage[a.sourceId])
              a.damageImage = this.productFaultInfo.damageImage[a.sourceId]
          })
      },
      faultInfoVerify() {
        if (!this.productSelected || this.productSelected.length == 0) {
          this.showFaultErrorMsg = true
          window.console.log('no found products')
          return false
        }
        let verified = true
        for (let i in this.productSelected) {
          const item = this.productSelected[i]
          const first = verified ? true : false

          if (this.store == 'sg' || this.store == 'my' || this.store == 'hk' ) {
            if (this.serviceRequired == 'refund') {
              window.console.log('This is refund, do checkbox verification')
              // for SG Refunds, there will not be cosmetic issues, so set default = false
              this.productFaultInfo.cosmetic[item.sourceId] = false

              if (this.productFaultInfo.returnAgree[item.sourceId] && this.productFaultInfo.returnAgree[item.sourceId]) {
                let returnAgree = { ...this.productFaultInfo.returnAgree }
                returnAgree[item.sourceId] = true
              }
              else {
                this.showAgreeMsg = true
                this.updateFaultMsg({ field: 'returnAgreeMsg', value: true })
                verified = false
              }
            }
            else {

            window.console.log('This is replacement, NO NEED verification')
            }
          }

          if (!this.productFaultInfo.reason[item.sourceId] || this.productFaultInfo.reason[item.sourceId].length == 0)
          {
            let reasonMsg = { ...this.productFaultInfo.reasonMsg }
            reasonMsg[item.sourceId] = true
            this.updateFaultMsg({field: 'reasonMsg', value: reasonMsg})
            window.console.log(`no found reason for ${item.name}`)
            verified = false
          }

          if (item.faultCode && item.faultCode == 'DEFECTIVE') {
            // this.showFaultErrorMsg = true
            let faultCatMsg = { ...this.productFaultInfo.faultCatMsg }
            faultCatMsg[item.sourceId] = true
            this.updateFaultMsg({field: 'faultCatMsg', value: faultCatMsg})
            let faultCodeMsg = { ...this.productFaultInfo.faultCodeMsg}
            faultCodeMsg[item.sourceId] = true
            this.updateFaultMsg({field: 'faultCodeMsg', value: faultCodeMsg})
            window.console.log(`no found fault code for ${item.name}`)
            verified = false
          }

          if (this.store == 'jp' && (!item.comments || item.comments.length == 0)) {
            let commentsMsg = { ...this.productFaultInfo.commentsMsg }
            commentsMsg[item.sourceId] = true
            this.updateFaultMsg({field: 'commentsMsg', value: commentsMsg})
            verified = false
          }


          if (item.faultCode && item.faultCode=='OTH01' && (!item.otherComments || item.otherComments.length == 0)) {
            // this.showFaultErrorMsg = true
            let otherCommentsMsg = { ...this.productFaultInfo.otherCommentsMsg }
            otherCommentsMsg[item.sourceId] = true
            this.updateFaultMsg({field: 'otherCommentsMsg', value: otherCommentsMsg})
            window.console.log(`no found other comments for ${item.name}`)
            verified = false
          }
          if (this.productFaultInfo.cosmetic[item.sourceId] == undefined) {
            let cosmeticMsg = { ...this.productFaultInfo.cosmeticMsg }
            cosmeticMsg[item.sourceId] = true
            this.updateFaultMsg({field: 'cosmeticMsg', value: cosmeticMsg})
            window.console.log(`no select for ${item.name}`)
            // this.showFaultErrorMsg = true
            verified = false
          }
          if (this.productFaultInfo.cosmetic[item.sourceId] && (!item.damageImage || item.damageImage.length == 0)) {
            let damageImageMsg = { ...this.productFaultInfo.damageImageMsg }
            damageImageMsg[item.sourceId] = true
            this.updateFaultMsg({field: 'damageImageMsg', value: damageImageMsg})
            window.console.log(`no found damage image for ${item.name}`)
            // this.showFaultErrorMsg = true
            verified = false
          }
          if (first) this.activeTab = 'tab'+item.sourceId
        }

        return verified
      },
      reasonTabChanged(id) {
        this.activeTab = id
      },
      loadAvailableMsg(data) {
        this.refundNotAvailable = ''
        this.repairNotAvailable = ''

        if (data && data.length > 0) {
          let refundNotAvailable = data.filter(a => { return a.returnsEligibility == true })
          if (refundNotAvailable && refundNotAvailable.length != data.length) {
            refundNotAvailable.forEach(a => {
              this.refundNotAvailable += a.name + ', '
            })
          }
          if (this.refundNotAvailable.length > 0)
            this.refundNotAvailable = this.refundNotAvailable.substring(0, this.refundNotAvailable.length - 2)
          let repairNotAvailable = data.filter(a => { return a.warrantyDaysRemain > 0 })
          if (repairNotAvailable && repairNotAvailable.length != data.length) {
            repairNotAvailable.forEach(a => {
              this.repairNotAvailable += a.name + ', '
            })
          }
          if (this.repairNotAvailable.length > 0)
            this.repairNotAvailable = this.repairNotAvailable.substring(0, this.repairNotAvailable.length - 2)
        }
      },
      forceRerenderReasonSection() {
        this.renderReasonSection = false
        this.$nextTick(()=>{
          this.renderReasonSection = true
        })
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import "~vue-material/dist/theme/engine";
</style>